// extracted by mini-css-extract-plugin
export default {"groupQuestionCard":"GroupQuestionCard_groupQuestionCard__PfSpO"};